// Permission codes are the backend codes verbatim (no PT↔EN alias). The set the
// user holds comes straight from GET /auth/me. `Permission` is a string; the
// constants below are just the ones referenced in the UI (autocomplete/safety).

export type Permission = string;

export const PERM = {
  workspacesRead: "workspaces.read",
  workspacesWrite: "workspaces.write",
  workspacesDelete: "workspaces.delete",
  workspacesPlansWrite: "workspaces.plans.write",
  rolesRead: "roles.read",
  rolesWrite: "roles.write",
  accessGrantsWrite: "access_grants.write",
} as const;
